var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkAccess('sites-summary-report'))?_c('report-list-page',{attrs:{"page-title":"Site Report","page-icon":"mdi-group","descending":true,"headers":_vm.headers,"state-end-point":"invoice.sitesSummaries","actions":_vm.actions,"show-component":_vm.showComponent,"item-key":"id"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }